import {enumDef} from "@/common/enumDefs";
import {localization} from "@/common/lang/localization";

function hasRequiredTraderType(user, allowedTraderTypes) {
	if (!allowedTraderTypes) {
		return true;
	}

	return allowedTraderTypes.includes(user.companyTraderType);
}

function hasAccess(user, permission) {
	if (!permission) {
		return true;
	}

	return user
		? user.actions.find(action => action.resources === permission) !== undefined
		: false;
}

function missingPermissionTooltipKey(permission, user) {
	let property = enumDef.permissions.properties[permission];

	if (property && property.missingPermissionTooltipKey) {
		if (property instanceof Object) {
			return enumDef.userLevel.isAdminUser(user.level)
				? property.missingPermissionTooltipKey.adminUser
				: property.missingPermissionTooltipKey.normalUser || "common.missingPermission";
		} else {
			return property.missingPermissionTooltipKey;
		}
	}

	return "common.missingPermission";
}

function accessDeniedTooltip(user, permission) {
	return localization.i18n.t(missingPermissionTooltipKey(permission, user));
}

export {
	hasRequiredTraderType,
	hasAccess,
	accessDeniedTooltip
}